"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMatches = exports.isValid = void 0;
const isValid = (regex, str) => {
    const re = new RegExp(regex, "g");
    const t = str.match(re);
    return Array.isArray(t);
};
exports.isValid = isValid;
const getMatches = (regex, str, { flags = "g", depth = 0 } = {}) => {
    const re = new RegExp(regex, flags);
    let match = null;
    const matches = [];
    do {
        match = re.exec(str);
        if (match) {
            matches.push(match[depth]);
        }
    } while (match != null);
    return matches;
};
exports.getMatches = getMatches;
